import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PDFViewerComponent } from './pdf-viewer.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { LocalLoaderComponent } from '../../../../../../components/loader/local-loader/local-loader.component';
import { SafeURLModule } from '../../../../../../core/pipes/safe-url/safe-url.module';

@NgModule({
  declarations: [PDFViewerComponent],
  imports: [CommonModule, SafeURLModule, LocalLoaderComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        PDFViewerComponent: {
          component: PDFViewerComponent,
        },
      },
    }),
  ],
  exports: [PDFViewerComponent],
})
export class PDFViewerModule {}
